export default __webpack_public_path__ + "static/media/team.72d138df.svg";